// The `/chat` handshake for every portal chat socket (design D8).
//
// The session travels as the HTTP-only `authToken_patient` cookie the browser
// already holds; no token is passed and none is kept in memory. `tenant:
// "patient"` tells the server which cookie is this page's session, so a clinic
// cookie on the same `.brightlight.ai` domain is never read. `forceNew` gives
// the socket its own engine connection: the cookie rides the engine's first
// request, and a Manager the `/` socket already opened without credentials
// would otherwise be reused.
export function chatSocketOptions({rooms, userId}) {
  return {
    withCredentials: true,
    forceNew: true,
    auth: {tenant: "patient", rooms, userId},
  };
}

// A namespace middleware refusal carries `err.data.code` on the
// `connect_error` the client receives, and Socket.IO never retries it. Any
// other `connect_error` (a network hiccup, the server being down) has no code
// and is retried as usual.
export function chatConnectRefusalCode(err) {
  return err?.data?.code || null;
}

// Registers the refusal listener for a `/chat` socket. `onRefused(code)` runs
// only for a coded refusal, never for a network error that will be retried.
export function onChatRefusal(socket, onRefused) {
  socket.on("connect_error", (err) => {
    const code = chatConnectRefusalCode(err);
    if (code) onRefused(code);
  });
}
